// libraries.
import { Button, ButtonGroup } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

// slices.
import {
  getPolygonTypeFilter,
  setPolygonTypeFilter,
} from '@domains/polygon-tool';
import type { PolygonTypeFilter as PolygonTypeFilterValue } from '../store/slices/polygon-slice';

// styles.
import { StyledPolygonTypeFilter } from './styles';

interface FilterOption {
  label: string;
  value: PolygonTypeFilterValue;
}

const FILTER_OPTIONS: FilterOption[] = [
  { label: 'Todos', value: 'all' },
  { label: 'Solo bloqueos', value: 'blocking' },
  { label: 'Solo estándar', value: 'standard' },
];

export const PolygonTypeFilter = () => {
  const dispatch = useDispatch();
  const current = useSelector(getPolygonTypeFilter);

  const handleSelect = (value: PolygonTypeFilterValue) => {
    dispatch(setPolygonTypeFilter(value));
  };

  return (
    <StyledPolygonTypeFilter>
      <ButtonGroup aria-label="Filtro de tipo de polígono">
        {FILTER_OPTIONS.map(({ label, value }) => (
          <Button
            key={value}
            className={current === value ? 'btn-habi' : 'btn-habi-white'}
            onClick={() => handleSelect(value)}
          >
            {label}
          </Button>
        ))}
      </ButtonGroup>
    </StyledPolygonTypeFilter>
  );
};
